import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

/**
 * Componente Select reutilizable con estilos consistentes
 * @param {string} label - Etiqueta del campo
 * @param {string} value - Valor actual
 * @param {function} onChange - Función que se ejecuta al cambiar
 * @param {array} options - Array de opciones [{value, label}]
 * @param {boolean} required - Si el campo es requerido
 * @param {boolean} disabled - Si el campo está deshabilitado
 * @param {string} placeholder - Texto para opción vacía (opcional)
 * @param {string} name - Nombre del campo para el formulario
 */
const FormSelect = ({
  label,
  value,
  onChange,
  options = [],
  required = false,
  disabled = false,
  placeholder = 'Selecciona una opción',
  name,
  ...props
}) => {
  return (
    <FormControl fullWidth required={required} disabled={disabled}>
      <InputLabel 
        shrink 
        sx={{ 
          bgcolor: 'background.paper', 
          px: 1,
          fontSize: '1rem'
        }}
      >
        {label}
      </InputLabel>
      <Select
        value={value || ''}
        onChange={onChange}
        name={name}
        displayEmpty
        sx={{
          '& .MuiSelect-select': {
            py: 1.5,
            display: 'flex',
            alignItems: 'center'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1.5
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderWidth: 2
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 2
          }
        }}
        {...props}
      >
        <MenuItem value="" disabled sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
          {placeholder}
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FormSelect;
